const CONFIG = {
  SCRIPT_TYPE: 'text/javascript',
  SCRIPT_SRC: 'https://widget.whelp.co/app.js',
  SCRIPT_LOAD_ERROR: 'Whelp livechat script not loaded',
  SCRIPT_INIT_ERROR: 'Whelp livechat can not initialized',
  ENV_ERROR: 'WEBCHAT_ID environment variable is not defined',
};

export class WhelpLiveChat {
  constructor(ctx, CONFIG) {
    this.ctx = ctx;
    this.CONFIG = CONFIG;
  }

  loadAndInitScript() {
    if (document.querySelector(`script[src="${this.CONFIG.SCRIPT_SRC}"]`)) {
      this.initChat();
      return;
    }

    const theScript = document.createElement('script');
    theScript.defer = true;
    theScript.src = this.CONFIG.SCRIPT_SRC;
    theScript.type = this.CONFIG.SCRIPT_TYPE;
    theScript.onload = () => this.initChat();
    document.head.appendChild(theScript);
  }

  initChat() {
    const whelpLivechatInitializer = window.MainLivechatInitializer;

    if (!whelpLivechatInitializer || typeof whelpLivechatInitializer !== 'function') {
      this.ctx.app.$sentry.captureException(new Error(this.CONFIG.SCRIPT_INIT_ERROR));
      return;
    }

    if (!this.ctx.env.WEBCHAT_ID) {
      this.ctx.app.$sentry.captureException(new Error(this.CONFIG.ENV_ERROR));
      return;
    }

    whelpLivechatInitializer('init', { app_id: this.ctx.env.WEBCHAT_ID });
  }
}

export default (ctx, inject) => {
  const liveChat = new WhelpLiveChat(ctx, CONFIG);

  inject('liveChat', liveChat);
};
